export const searchPlaceHolder: any = {
  "/member": "Search by first name, last name, email or phone number",
  "/settings/owner": "Search by first name, last name, email or phone number",
};
